/**
 * AccountingIcon — document with a dollar-sign magnifier (lucide-compatible
 * props: className, strokeWidth). Used for the Home "$" sub-tab and the main
 * Accounting tab button.
 */
const AccountingIcon = ({ className = "h-4 w-4", strokeWidth = 2, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    {/* scroll body */}
    <path d="M6 4h8v3.5" />
    <path d="M6 4a2 2 0 0 0-2 2v1h2" />
    <path d="M6 7v11" />
    <path d="M6 18a2 2 0 0 0 2 2h11a2 2 0 0 1-2-2v-1" />
    <path d="M6 18h2" />
    <path d="M14 20h5" />
    <path d="M17 14v3" />
    {/* text lines */}
    <path d="M9 9h3" />
    <path d="M9 12h3.5" />
    <path d="M9 15h5" />
    {/* magnifier with $ */}
    <circle cx="16.5" cy="8.5" r="3.5" />
    <path d="M19 11l2.5 2.5" />
    <path d="M17.6 7.3c-.3-.4-.7-.6-1.1-.6-.6 0-1 .3-1 .8 0 1 2.1.5 2.1 1.6 0 .5-.5.9-1.1.9-.5 0-.9-.2-1.2-.6" />
    <path d="M16.5 6v.7M16.5 10.1v.7" />
  </svg>
);

export default AccountingIcon;
